<div class="modal-header">
  <h4 class="modal-title">Request for Image</h4>
  <button (click)="cancel()" aria-label="Close" class="modal-close" type="button">
    <font-awesome [icon]="'fa-regular fa-xmark'"></font-awesome>
  </button>
</div>

<div class="modal-body">
  <div class="img-container mb-24px">
    <img [src]="imageInfo | secure | async" class="w-100"/>
  </div>
  <!--
  <div class="d-flex mb-16px request-desc">
    Enter the reason for re-upload of picture.
    The entered description is passed on to th e requester
  </div>
  <div class="d-flex">
    <textarea rows="5" aria-multiline="true" [(ngModel)]="comment"
              [readOnly]="roles.cdCreator.includes(initInfo?.userType)"></textarea>
  </div>
  -->
</div>
<!--
<div class="modal-footer">
  <div class="d-flex justify-content-end w-100"
       *ngIf="!roles.cdCreator.includes(initInfo?.userType) && ['REVIEW', 'DATA'].includes(initInfo.status)">
    <button type="button" class="btn btn-185px btn-dark" (click)="save()">save</button>
  </div>
</div>
-->
